import { combineReducers } from "@reduxjs/toolkit";
import { bmInstructionSliceName, bmQuerySlice } from "./bmInstructionsSlice";

export const bmInstructionsRootSlice = combineReducers({
  [bmInstructionSliceName]: bmQuerySlice.reducer,
});

export type BmInstructionsRootStateType = ReturnType<
  typeof bmInstructionsRootSlice
>;

export * from "./bmInstructionsSlice";
export * from "./bmInstructionsSlice.selectors";

// Aliased for routerConfig
export const sliceReducer = bmInstructionsRootSlice;
